import { BaseResponse } from "@/types/dto/base-response";
import { LoginPayload } from "@/types/payload/sign-in-payload";
import { AxiosInstance } from "axios";
import { AccessTokenDto } from "../types/dto/access-token-dto";
import { baseApi } from "./base-api";

enum AuthServiceEndpoint {
  Login = "/auth/sign-in",
}

class AuthService {
  private static instance: AuthService;
  private _api: AxiosInstance;

  private constructor(api: AxiosInstance) {
    this._api = api;
  }

  static getInstance(apiClient = baseApi): AuthService {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService(apiClient);
    }
    return AuthService.instance;
  }

  async login(
    payload: LoginPayload
  ): Promise<BaseResponse<AccessTokenDto, LoginPayload>> {
    try {
      const response = await this._api.post<
        BaseResponse<AccessTokenDto, LoginPayload>
      >(AuthServiceEndpoint.Login, {
        email: payload.email,
        password: payload.password,
      });

      const responseData = response.data;
      if (responseData.ok) {
        localStorage.setItem("accessToken", responseData.data.access_token);
      }
      return responseData;
    } catch (error) {
      console.error("Error login:", error);
      throw error;
    }
  }
}

export const authService = AuthService.getInstance(baseApi);
